import { useMutation, useQueryClient } from "@tanstack/react-query";
import { EditDietFormValues } from "../schema/dietary-report.schema";
import { editDietReport } from "../api/dietary-report.api";
import { toast } from "react-toastify";
import { dietKeys } from "./useDietaryReports";

export const useEditDiet = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      reportId,
      values,
    }: {
      reportId: string;
      memberId: number;
      values: Partial<EditDietFormValues>;
    }) => editDietReport(reportId, values),

    onSuccess: (_, {memberId}) => {
      queryClient.invalidateQueries({ queryKey: dietKeys.list(memberId) });

      toast.success("Diet Report Updated!");
    },

    onError: () => {
      toast.error("Failed to Update Report!");
    },
  });
};
